module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hrms-dropzone",
    attrs: {
      "name": "hrms-dropzone"
    }
  }, [_c('vue-dropzone', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dispAttach),
      expression: "dispAttach"
    }],
    ref: 'vueDropzoneCall' + _vm.name,
    class: {
      'input-error': _vm.hasError
    },
    attrs: {
      "id": _vm.name,
      "url": _vm.url,
      "headers": _vm.headers,
      "useFontAwesome": true,
      "maxNumberOfFiles": _vm.maxNumberOfFiles,
      "showRemoveLink": _vm.showRemoveLink,
      "maxFileSizeInMB": _vm.maxFileSizeInMB,
      "acceptedFileTypes": _vm.acceptedFileTypes,
      "capture": _vm.capture,
      "resizeMethod": _vm.resizeMethod,
      "resizeWidth": _vm.resizeWidth,
      "resizeHeight": _vm.resizeHeight
    },
    on: {
      "vdropzone-sending": _vm.triggerSending,
      "vdropzone-removed-file": _vm.triggerRemoveFile,
      "vdropzone-success": _vm.triggerSuccessBuiltIn,
      "vdropzone-error": _vm.triggerError
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dispAttach),
      expression: "dispAttach"
    }],
    staticClass: "text-remark _text-blue"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flgEditInline),
      expression: "!flgEditInline"
    }]
  }, [_c('ul', [_c('li', [_vm._v("File name must only contain alphanumeric characters with no spaces and hiphen.")]), _vm._v(" "), _c('li', [_vm._v("Maximum size of 2 MB is allowed.")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispAttach),
      expression: "!dispAttach"
    }]
  }, [(['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(_vm.getFileExtension(_vm.inputFileName))) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flgPreview),
      expression: "flgPreview"
    }],
    staticClass: "img-upload-preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.filePath + _vm.inputFileName
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "img-upload-detail"
  }, [_vm._v("\n      " + _vm._s(_vm.inputFileName) + "\n      "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filePath + this.inputFileName),
      expression: "filePath + this.inputFileName"
    }],
    staticClass: "fa fa-paperclip ico-knowledge1 dash-color-skin",
    attrs: {
      "href": _vm.filePath + this.inputFileName,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filePath + this.inputFileName),
      expression: "filePath + this.inputFileName"
    }],
    staticClass: "fa fa-trash ico-knowledge1 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.deleteFileTemp()
      }
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4df9b4d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsDropzone/component.vue
// module id = 3744
// module chunks = 1